import localeText from "../../locale";

export async function uploadImages(image, toast, productService) {
  try {
    if (image && typeof image !== "string") {
      const res = await productService.postUploadImage(
        localStorage.getItem("__extraconomy_token"),
        image
      );
      if (res.messageCode !== 200000) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        if (res.messageCode === 500000) console.log(res);
        return false;
      } else {
        return res.result;
      }
    } else {
      return null;
    }
  } catch (e) {
    if (e.status === 401) {
      localStorage.removeItem("__extraconomy_token");
      localStorage.removeItem("__extraconomy_username");
      window.location.replace("/login");
    } else if (e.status === 500) {
      toast.current.show({
        severity: "error",
        summary: localeText("error"),
        detail: localeText("unexpectedSystemBehaviour"),
        life: 6000,
      });
    } else {
      toast.current.show({
        severity: "error",
        summary: localeText("error"),
        detail: localeText("unexpectedErrorUploadImg"),
        life: 6000,
      });
    }
  }
}
